import { isEmpty, map, slice, get } from 'lodash'
import moment from 'moment'

const addTimes = (dates, date, id, time) => {
  if (isEmpty(dates[date])) {
    dates[date] = []
  }

  dates[date].push({id, time, date})
}

const parsedDay = (date) => {
  return moment(date).format('DD/MM')
}

export default {
  filterPeriod (schedules) {
    const isPeriod = get(this.filters.schedules, 'period', 'null')

    if (isPeriod !== 'null') {
      if (isPeriod === 'morning') {
        let morningSchedules = schedules.filter((times) => {
          return times.horario_M !== null
        })

        return morningSchedules.slice(0, 4)
      }

      if (isPeriod === 'afternoon') {
        let morningSchedules = schedules.filter((times) => {
          return times.horario_T !== null
        })

        return morningSchedules.slice(0, 4)
      }

      if (isPeriod === 'nigth') {
        let morningSchedules = schedules.filter((times) => {
          return times.horario_N !== null
        })

        return morningSchedules.slice(0, 4)
      }
    }

    if (isPeriod === 'null') {
      return schedules.slice(0, 4)
    }
  },
  // Em qual periodo
  inWhichPeriod (item, filters) {
    const byPeriod = get(filters.schedules, 'period', 'null')

    if (byPeriod !== 'null') {
      // Is morning
      if (byPeriod === 'morning') {
        if (item.idagendamento_M !== null && item.horario_M !== null) {
          return item.horario_M.split(';').slice(0, 4)
        }
      }
      // is afternoon
      if (byPeriod === 'afternoon') {
        if (item.idagendamento_T !== null && item.horario_T !== null) {
          return item.horario_T.split(';').slice(0, 4)
        }
      }
      // is nigth
      if (byPeriod === 'nigth') {
        if (item.idagendamento_N !== null && item.horario_N !== null) {
          return item.horario_N.split(';').slice(0, 4)
        }
      }
    }
    if (byPeriod === 'null') {
      return item.horario.split(';').slice(0, 4)
    }
  },
  parsedDayDate (day, item, filters) {
    const byPeriod = get(filters.schedules, 'period', 'null')

    if (byPeriod !== 'null') {
      // Is morning
      if (byPeriod === 'morning') {
        if (item.idagendamento_M !== null && item.horario_M !== null) {
          return moment(day).format('DD/MM')
        }
      }
      // is afternoon
      if (byPeriod === 'afternoon') {
        if (item.idagendamento_T !== null && item.horario_T !== null) {
          return moment(day).format('DD/MM')
        }
      }
      // is nigth
      if (byPeriod === 'nigth') {
        if (item.idagendamento_N !== null && item.horario_N !== null) {
          return moment(day).format('DD/MM')
        }
      }
    }
    if (byPeriod === 'null') {
      return moment(day).format('DD/MM')
    }
  },
  parseTimeDate (time) {
    return time.slice(0, 5)
  },
  doLoad () {
    const dates = {}
    map(this.agenda.available_schedules, (item) => {
      const date = moment(item.date).format('YYYY-MM-DD')
      addTimes(dates, date, item.id, moment(item.date).format('HH:mm'))
    })
    const keys = Object.keys(dates)

    const schedules = map(keys, (key) => {
      const times = dates[key]

      const schedule = {
        date: parsedDay(key),
        dateComplete: key,
        times,
        showTimes: slice(times, 0, 3)
      }

      return schedule
    })

    this.schedules = slice(schedules, 0, 5)
  },
  hideForm () {
    this.showModal = false
  },
  showForm (schedule, i, period = {}) {
    const filterByPeriod = get(period.schedules, 'period', 'null')
    const periods = [
      'morning',
      'afternoon',
      'nigth'
    ]

    // caso não seja informado o periodo
    if (!periods.includes(period)) {
      // Id agendamentos
      const scheduleId = schedule.idagendamento.split(';')
      // Horarios do agendamento
      const scheduleTime = schedule.horario.split(';')
      this.doScheduling(scheduleId, scheduleTime, i, schedule)
    }

    // manha
    if (filterByPeriod === 'morning') {
       // Id agendamentos
      const scheduleId = schedule.idagendamento_M.split(';')
      // Horarios do agendamento
      const scheduleTime = schedule.horario_M.split(';')
      this.doScheduling(scheduleId, scheduleTime, i, schedule)
    }

    // tarde
    if (filterByPeriod === 'afternoon') {
      // Id agendamentos
      const scheduleId = schedule.idagendamento_T.split(';')
      // Horarios do agendamento
      const scheduleTime = schedule.horario_T.split(';')
      this.doScheduling(scheduleId, scheduleTime, i, schedule)
    }

    // Noite
    if (filterByPeriod === 'nigth') {
      // Id agendamentos
      const scheduleId = schedule.idagendamento_N.split(';')
      // Horarios do agendamento
      const scheduleTime = schedule.horario_N.split(';')
      this.doScheduling(scheduleId, scheduleTime, i, schedule)
    }
  },
  doScheduling (id, time, i, schedule) {
    const isTime = {id: id[i], time: time[i]}
    this.showModal = true
    this.currentItem = schedule
    this.currentTime = isTime

    this.currentPatient = this.filters.patient
    this.currentCovenant = this.filters.covenant
  },
  showMore () {
    console.log('entrou aqui showMore')
  },
  setSchedule (value) {
    this.scheduled.push(value)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/methods.js